import React, { useCallback } from "react";
import { Send } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import useAuthorized from "hooks/useAuthorized";
import AccountModal from "routes/constant_contact/components/AccountModal";
import ConstantContactAccountsService from "services/ConstantContactAccounts";
import {
  invalidateAccountsQuery,
  useAccountsTable,
} from "hooks/useAccountsTable";

export const ACCOUNTS_TABLE_CONSTANTS = {
  tableName: "accountsTable",
  queryKey: "accounts-table",
  className: "Account",
  exportTableName: null,
  header: "Constant Contact Accounts",
  headerIcon: Send,
};

const AccountsTableV3 = () => {
  const { columns } = useAccountsTable();
  const canCreate = useAuthorized([
    ACL_RELATIONSHIPS.constantContactAccounts.create,
  ]);

  const fetchAccounts = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response =
          await ConstantContactAccountsService.getTable(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching accounts:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      queryKey={ACCOUNTS_TABLE_CONSTANTS.queryKey}
      tableName={ACCOUNTS_TABLE_CONSTANTS.tableName}
      className={ACCOUNTS_TABLE_CONSTANTS.className}
      header={ACCOUNTS_TABLE_CONSTANTS.header}
      headerIcon={ACCOUNTS_TABLE_CONSTANTS.headerIcon}
      enableSettings
      createButton={canCreate ? <AccountModal /> : null}
      fetchData={fetchAccounts}
      invalidateData={invalidateAccountsQuery}
    />
  );
};

export default AccountsTableV3;
